<div class="card section-card h-100" [formGroup]="validationDemoForm">
  <div class="card-header">{{ 'i18n.domain.theme-showcase.syncfusion.title' | translate }}</div>
  <div class="card-body">
    <div class="row g-3">
      <div class="col-12 col-md-6">
        <label class="form-label">{{ 'i18n.domain.theme-showcase.syncfusion.client' | translate }}</label>
        <ejs-dropdownlist
          [dataSource]="clientOptions"
          [fields]="dropdownFields"
          formControlName="syncfusionClient"
          [showClearButton]="true"
          [placeholder]="'i18n.domain.theme-showcase.syncfusion.clientPlaceholder' | translate">
        </ejs-dropdownlist>
        <app-error-messages [control]="formFields.syncfusionClient" [showUntouchedErrors]="validationAttempted"></app-error-messages>
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label">{{ 'i18n.domain.theme-showcase.syncfusion.client' | translate }}  ({{'i18n.shared.disabled' | translate}})</label>
        <ejs-dropdownlist
          [dataSource]="clientOptions"
          [fields]="dropdownFields"
          [value]="clientOptions[0].value"
          [enabled]="false">
        </ejs-dropdownlist>
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label">{{ 'i18n.domain.theme-showcase.syncfusion.location' | translate }}</label>
        <ejs-autocomplete
          [dataSource]="locationOptions"
          formControlName="syncfusionLocation"
          [placeholder]="'i18n.domain.theme-showcase.syncfusion.locationPlaceholder' | translate">
        </ejs-autocomplete>
        <app-error-messages [control]="formFields.syncfusionLocation" [showUntouchedErrors]="validationAttempted"></app-error-messages>
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label">{{ 'i18n.domain.theme-showcase.syncfusion.location' | translate }}  ({{'i18n.shared.disabled' | translate}})</label>
        <ejs-autocomplete
          [enabled]="false"
          [dataSource]="locationOptions"
          [placeholder]="'i18n.domain.theme-showcase.syncfusion.locationPlaceholder' | translate"
          [value]="locationOptions[0]">
        </ejs-autocomplete>
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label">{{ 'i18n.domain.theme-showcase.syncfusion.date' | translate }}</label>
        <ejs-datepicker
          formControlName="syncfusionDate"
          format="dd.MM.yyyy">
        </ejs-datepicker>
        <app-error-messages [control]="formFields.syncfusionDate" [showUntouchedErrors]="validationAttempted"></app-error-messages>
      </div>

      <div class="col-12 col-md-6">
        <label class="form-label">{{ 'i18n.domain.theme-showcase.syncfusion.date' | translate }}  ({{'i18n.shared.disabled' | translate}})</label>
        <ejs-datepicker
          [value]="selectedDate"
          format="dd.MM.yyyy"
          [enabled]="false">
        </ejs-datepicker>
      </div>

      <div class="col-12 col-md-6 d-flex align-items-end">
        <ejs-checkbox
          cssClass="checkbox-large"
          [checked]="syncfusionCheckboxChecked"
          [label]="'i18n.domain.theme-showcase.syncfusion.checkboxLabel' | translate"
          (change)="onCheckboxChanged($event)">
        </ejs-checkbox>
      </div>

      <div class="col-12 col-md-6 d-flex align-items-end">
        <ejs-checkbox
          cssClass="checkbox-large"
          [checked]="syncfusionCheckboxChecked"
          [label]="'i18n.domain.theme-showcase.syncfusion.checkboxLabel' | translate"
          (change)="onCheckboxChanged($event)"
          [disabled]="true">
        </ejs-checkbox>
      </div>
    </div>

    <div class="d-flex flex-wrap gap-2 mt-3">
      <ejs-tooltip [content]="'i18n.domain.theme-showcase.syncfusion.tooltip' | translate">
        <button class="btn btn-outline-secondary" type="button">{{ 'i18n.domain.theme-showcase.syncfusion.tooltipTrigger' | translate }}</button>
      </ejs-tooltip>
      <button class="btn btn-outline-secondary" type="button" (click)="openDialog()">{{ 'i18n.domain.theme-showcase.syncfusion.openDialog' | translate }}</button>
      <button
        ejs-dropdownbutton
        [content]="'i18n.domain.theme-showcase.syncfusion.dropdownAction' | translate"
        [items]="splitButtonItems"
        (select)="onActionSelected($event)"></button>
    </div>

    <div class="d-flex flex-wrap gap-2 mt-3">
      <button class="btn btn-outline-success" type="button" (click)="showSuccessToast()">{{ 'i18n.domain.theme-showcase.syncfusion.showToast' | translate }}</button>
      <button class="btn btn-outline-warning" type="button" (click)="showWarningToast()">{{ 'i18n.domain.theme-showcase.syncfusion.showWarningToast' | translate }}</button>
      <button class="btn btn-outline-danger" type="button" (click)="showErrorToast()">{{ 'i18n.domain.theme-showcase.syncfusion.showErrorToast' | translate }}</button>
    </div>
  </div>
</div>

<ejs-dialog
  [isModal]="true"
  [showCloseIcon]="true"
  [visible]="isDialogOpen"
  width="420px"
  cssClass="modal-sm"
  (close)="closeDialog()">
  <ng-template #header>
    {{ 'i18n.domain.theme-showcase.dialog.title' | translate }}
  </ng-template>
  <ng-template #content>
    {{ 'i18n.domain.theme-showcase.dialog.content' | translate }}
  </ng-template>
  <ng-template #footerTemplate>
    <button type="button" class="btn btn-outline-secondary me-2" (click)="closeDialog()">{{ 'i18n.shared.close' | translate }}</button>
    <button type="button" class="btn btn-primary" (click)="closeDialog()">{{ 'i18n.shared.ok' | translate }}</button>
  </ng-template>
</ejs-dialog>
